export function humaniseString(string) {
  const frags = string.split(/[-/_]/);
  for (let i = 0; i < frags.length; i++) {
    frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
  }
  return frags.join(' ');
}

export function lowercaseHyphen(text) {
  return text.split(' ').join('-').toLowerCase();
}

export function uppercaseUnderscore(text) {
  return text.split(' ').join('_').toUpperCase();
}

export function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function truncateString(str, max, add) {
  add = add || '...';
  return (typeof str === 'string' && str.length > max ? str.substring(0, max) + add : str);
}



// WEBPACK FOOTER //
// ./library/app/utils/stringConversion.js